// Don Diseños — Theme JS

// NFC Tap Demo interaction
(function() {
  const stage = document.getElementById('demoStage');
  const hintCta = document.getElementById('hintCta');
  if (!stage) return;

  let tapped = false;
  let tapTimeout;

  function triggerTap() {
    document.body.classList.add('tapped');
    if (hintCta) hintCta.textContent = 'Tap again ↺';
    tapped = true;
    clearTimeout(tapTimeout);
    tapTimeout = setTimeout(() => {
      document.body.classList.remove('tapped');
      if (hintCta) hintCta.textContent = 'Click to tap';
      tapped = false;
    }, 5000);
  }

  stage.addEventListener('click', () => {
    if (tapped) {
      document.body.classList.remove('tapped');
      if (hintCta) hintCta.textContent = 'Click to tap';
      tapped = false;
      clearTimeout(tapTimeout);
    } else {
      triggerTap();
    }
  });

  // Auto-play once on first scroll into view
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting && !tapped) {
          setTimeout(triggerTap, 600);
          io.disconnect();
        }
      });
    }, { threshold: 0.4 });
    io.observe(stage);
  }
})();
